<template>
  <div>
    <app-spinner v-if="!page_loaded"/>
    <template v-else>
      <h1 class="title">{{ supplier_data.trade_name }}</h1>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Trade name:</span> <span>{{ supplier_data.trade_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-tabs :tabs="tabs"/>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </template>
  </div>
</template>

<script>
import { getStorageSuppliersDetail } from '@/http'
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'StorageSupplierPricesDetail',
  components: {AppTabs},
  data() {
    return {
      page_loaded: false,
      supplier_data: {},
      tabs: [{name: 'storage-supplier-prices-detail', label: 'Items'}],
    }
  },
  created() {
    getStorageSuppliersDetail(this.$route.params.id)
      .then(response => {
        this.supplier_data = response.data
        this.page_loaded = true
      })
  }
}
</script>

